export const createChangeRequestStoreKey = (id: string, workId: string) => {
  const numId = parseInt(id);
  const timestamp = isNaN(numId) ? Date.now() : numId;
  const dateTime = new Date(timestamp).toISOString().substring(0, 19);
  const key = `CR@${dateTime}@${workId}`;
  return key;
};
